export default "__VITE_ASSET__B7hESDbE__"